#import "./PolicyDetailFields.graphql"

mutation DismissPolicySummarySuggestion($documentId: ID!) {
  dismissPolicySummarySuggestion(input: { documentId: $documentId }) {
    policy {
      ...PolicyDetailFields
    }
  }
}
